(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["teaser-legacy"] && !Shopify.designMode) return;
  try {
    
  class TeaserForm extends HTMLElement {
    constructor() {
      super();
      this.companyID = this.dataset.companyId;
      this.listID = this.dataset.listId;
    }
    
    connectedCallback() {
      this.addEventListener('click', e => {
        if (!e.target.closest('[data-action="submit-form"]')) return;
        
        this.submitForm();
      });
    }
    
    submitForm() {
      const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyID}`;
      const options = {
        method: 'POST',
        headers: { revision: '2023-10-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Custom teaser form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.querySelector('[data-email]').value,
                    first_name: this.querySelector('[data-full-name]').value.split(' ')[0],
                    last_name: this.querySelector('[data-full-name]').value.split(' ')[1]
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: this.listID
                }
              }
            }
          }
        })
      };
  
      fetch(url, options)
        .then(res => {
          if (res.status === 202) {
            this.classList.add('success');
          }
          return res.json();
        })
        .then(json => console.log(json))
        .catch(err => console.error('error:' + err));
    }
  }
  
  customElements.define('teaser-form', TeaserForm);
  
  class TeaserStage extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.addEventListener('click', e => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const { action } = clickedElement.dataset;
        switch(action) {
          case 'previous':
            if (this.classList.contains('center')) {
              this.classList.replace('center', 'first');
              return;
            }
            
            this.classList.replace('last', 'center');
          break;
          case 'next':
            if (this.classList.contains('center')) {
              this.classList.replace('center', 'last');
              return;
            }
            
            this.classList.replace('first', 'center');
          break;
          
          default: break;
        }
      });

      const desktop_video = document.getElementById('desktop-video');

      if (desktop_video) {
        const hue_layer = document.querySelector('[data-hue-layer]');

        hue_layer.addEventListener('mouseenter', () => {
          desktop_video.play();
        });

        hue_layer.addEventListener('mouseleave', () => {
          desktop_video.pause();
          desktop_video.currentTime = 0;
        });
      }
    }
  }
  
  customElements.define('teaser-stage', TeaserStage);    

  } catch(e) { console.error(e); }
})();
})();
